import { Button, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';

interface ConfirmRedoDialogProps {
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export const ConfirmRedoDialog = ({
  onClose,
  onConfirm,
  isLoading,
}: ConfirmRedoDialogProps) => (
  <BaseDialog
    onClose={onClose}
    title="Tem certeza de que deseja refazer a recomendação?"
    icon={<Icon name="siren-rounded" />}
    actionsComponent={
      <>
        <Button onClick={onClose}>Voltar</Button>
        <Button variant="contained" onClick={onConfirm} loading={isLoading}>
          Refazer a recomendação
        </Button>
      </>
    }
  >
    <Typography gutterBottom>
      As sugestões atuais serão descartadas, e você precisará responder ao
      questionário novamente.
    </Typography>
    <Typography>
      Lembre-se: é possível adicionar manualmente outras atividades após esta
      etapa de recomendação.
    </Typography>
  </BaseDialog>
);
